var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/require-default-props */
import React from 'react';
import { string, node, func } from 'prop-types';
import { v4 as uuidv4 } from "uuid";
import styled from 'styled-components';
import Heading from '../heading/Heading';
import Link from '../link/Link';

var getUUIDArray = function getUUIDArray(count) {
  var result = [];

  for (var i = 0; i <= count; i += 1) {
    result.push(uuidv4());
  }

  return result;
};

var PromoWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: grid;\n  border: 1px solid #cfd8dc;\n  background-color: #fff;\n  border-radius: 5px;\n  padding: 2.5rem 1.25rem;\n\n  @media (min-width: 769px) {\n    grid-template-columns: auto auto;\n    padding: 2.5rem;\n  }\n"])));
PromoWrapper.displayName = 'PromoWrapper';
var LeftColumn = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\n"])));
LeftColumn.displayName = 'LeftColumn';
var RightColumn = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\n"])));
RightColumn.displayName = 'RightColumn';
var PromoTitle = styled(Heading)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin: 0;\n\n  @media (min-width: 769px) {\n    padding: 0 1.25rem 0 0;\n  }\n"])));
PromoTitle.displayName = 'PromoTitle';
var ImageWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding-top: 2.5rem;\n  max-width: max-content;\n  margin: auto;\n\n  @media (min-width: 769px) {\n    padding: 0 0 2rem 0;\n    margin: auto;\n  }\n"])));
ImageWrapper.displayName = 'ImageWrapper';
var ImageFit = styled.img(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  max-width: 100%;\n  max-height: auto;\n\n  @media (min-width: 769px) {\n    width: auto;\n    max-width: unset;\n    max-height: unset;\n  }\n"])));
ImageWrapper.displayName = 'ImageWrapper';
var ChildRow = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  padding: 1.25rem 0 0 0;\n  @media (min-width: 769px) {\n    grid-row-start: 3;\n    grid-column-start: 1;\n    padding-right: 1.25rem;\n  }\n"])));
ChildRow.displayName = 'ChildRow';
var Description = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  padding: 1.25rem 0 0 0;\n  margin-top: 0px;\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 28px;\n\n  @media (min-width: 769px) {\n    padding-right: 1.25rem;\n  }\n"])));
Description.displayName = 'Description'; // *** TODO: REPLACE BELOW WITH NEW BUTTON COMPONENT ***

var ButtonContainer = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 1.25rem 0 0 0;\n  color: transparent;\n  text-decoration: none;\n  border-bottom: 0px;\n\n  @media (min-width: 769px) {\n    grid-row-start: 4;\n    grid-column-start: 1;\n    width: 300px;\n    padding: 3rem 0 0 0;\n  }\n"])));
ButtonContainer.displayName = 'ButtonContainer';
var Button = styled.button(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 60px;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 28px;\n  text-align: center;\n  background-color: #6599b3;\n  border-style: none;\n  border-radius: 5px;\n  margin: auto;\n\n  &:hover {\n    background-color: #4C809A;\n  }\n\n  &:focus {\n    outline: none;\n  }\n"])));
Button.displayName = 'Button'; // *** TODO: REPLACE ABOVE HERE WITH NEW BUTTON COMPONENT ***

var Promo = function Promo(_ref) {
  var className = _ref.className,
      title = _ref.title,
      description = _ref.description,
      buttonText = _ref.buttonText,
      buttonLink = _ref.buttonLink,
      dataAnalyticsLabel = _ref.dataAnalyticsLabel,
      dataAnalyticsId = _ref.dataAnalyticsId,
      imageUrl = _ref.imageUrl,
      imageAlt = _ref.imageAlt,
      onButtonClick = _ref.onButtonClick,
      children = _ref.children;
  var arChildren = React.Children.toArray(children);
  var arKeys = getUUIDArray(arChildren.length);
  return /*#__PURE__*/React.createElement(PromoWrapper, {
    className: className
  }, /*#__PURE__*/React.createElement(LeftColumn, null, /*#__PURE__*/React.createElement(PromoTitle, {
    variant: 2
  }, title), description && /*#__PURE__*/React.createElement(Description, null, description), arChildren.map(function (item, index) {
    return /*#__PURE__*/React.createElement(ChildRow, {
      key: arKeys[index]
    }, item);
  }), buttonLink && buttonText && /*#__PURE__*/React.createElement(ButtonContainer, null, /*#__PURE__*/React.createElement(Link, {
    onClick: onButtonClick,
    href: buttonLink,
    dataAnalyticsId: dataAnalyticsId,
    dataAnalyticsLabel: dataAnalyticsLabel,
    target: "_self"
  }, /*#__PURE__*/React.createElement(Button, null, buttonText)))), /*#__PURE__*/React.createElement(RightColumn, null, /*#__PURE__*/React.createElement(ImageWrapper, null, /*#__PURE__*/React.createElement(ImageFit, {
    src: imageUrl,
    alt: imageAlt
  }))));
};

Promo.propTypes = {
  /**
  Optional for passing a class
  */
  className: string,

  /**
  Required for displaying a title
  */
  title: string.isRequired,

  /**
  Optional for displaying text directly below the title
  */
  description: string,

  /**
  Required text displayed on button. Pairs with buttonLink
  */
  buttonText: string.isRequired,

  /**
  Required link from button. Pairs with buttonText
  */
  buttonLink: string.isRequired,

  /**
  Optional button analytics label
  */
  dataAnalyticsLabel: string,

  /**
  Optional button analytics id
  */
  dataAnalyticsId: string,

  /**
  Optional path to feature image
  */
  imageUrl: string,

  /**
  Optional alt test for image
  */
  imageAlt: string,

  /**
  Optional function on button click
  */
  onButtonClick: func,

  /**
  Required children
  */
  children: node.isRequired
};
export default Promo;